/* eslint-disable */
import Cookie from '../../_common/scripts/cookie';
import $ from 'jquery';

export default class SalesforceForm {
  constructor(selector) {
    $(selector).on('submit', (e) => {
      const { target: form } = e;
      const { full_name, email, phone, state, newsletter_signup, retURL } = form;
      const first_name = form.querySelector('[name="first_name"]');
      const last_name = form.querySelector('[name="last_name"]');

      // Clearing data
      full_name.value = full_name.value.trim();
      email.value = email.value.trim();
      phone.value = phone.value.trim();
      state.value = state.value.trim();
      phone.value = phone.value.replace(/^\+61/, '0').replace(/\D/g, '');

      first_name.value = full_name.value.substr(0, full_name.value.indexOf(' '));
      last_name.value = full_name.value.substr(full_name.value.indexOf(' ') + 1);

      if ('undefined' !== typeof vtk_cid) {
        form.Campaign_ID.value = vtk_cid;
      }

      // add first referrer and most referrer information
      const recent_referrer = new Cookie("mr_ref"); //most recent referrer
      const first_referrer = new Cookie("f_ref"); //first referrer

      // set first referrer
      const meta = {
        '00N2w000008uAYp': this.getDomainName(recent_referrer.ref_url),
        '00N2w000008uAbF': this.getDomainName(first_referrer.ref_url),
        '00N2w000008uAb0': recent_referrer.ref_url,
        '00N2w000008uAb5': first_referrer.ref_url
      };
      Object
        .keys(meta)
        .forEach(name => {
          document
            .querySelectorAll(`[name="${name}"]`)
            .forEach(input => input.value = meta[name]);
        });

      const urlExtra = new URLSearchParams({
        newsletter: (newsletter_signup && newsletter_signup.checked) | 0,
        lastName: last_name.value,
        name: first_name.value,
        email: email.value
      });

      retURL.value += `&${urlExtra}`;
    });
  }

  getDomainName(url) {
    let domain_name = "";

    if ((url !== '') && (typeof url === 'string')) {
      url = url.toLowerCase();

      const url_parts = url.split("/");
      const is_http = url.indexOf("http://");
      const is_https = url.indexOf("https://");

      if (is_http === -1 && is_https === -1) {
        domain_name = url_parts[0];
      } else {
        domain_name = url_parts[2];
      }
    }

    return domain_name;
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/salesforce-form.js